import { render, staticRenderFns } from "./projectInfo.vue?vue&type=template&id=720e7e9e&"
import script from "./projectInfo.vue?vue&type=script&lang=js&"
export * from "./projectInfo.vue?vue&type=script&lang=js&"
import style0 from "./projectInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports